// app_client/src/store/useExchangeStore.js
import { create } from 'zustand';

const useExchangeStore = create((set, get) => ({
  rates: {
    USD: 1,
    EUR: 1,
    GBP: 1,
    TRY: 1
  },
  loading: false,
  lastUpdated: null,

  // Kurları API'den çekme fonksiyonu
  fetchRates: async () => {
    try {
      const res = await fetch("https://api.bigpara.hurriyet.com.tr/doviz/headerlist");
      const result = await res.json();
      const data = result.data;

      if (!data || !Array.isArray(data)) return;

      const usdData = data.find(i => i.SEMBOL === "USDTRY");
      const eurData = data.find(i => i.SEMBOL === "EURTRY");
      const gbpData = data.find(i => i.SEMBOL === "GBPTRY");

      // Veri tipine göre güvenli dönüştürme fonksiyonu
      const parseRate = (val) => {
        if (!val) return 1;
        // Eğer değer zaten sayıysa direkt döndür
        if (typeof val === 'number') return val;
        // Eğer metinse ve içinde virgül varsa noktaya çevirip sayıya dönüştür
        if (typeof val === 'string') {
          return parseFloat(val.replace(',', '.'));
        }
        return parseFloat(val) || 1;
      };

      const newRates = {
        TRY: 1,
        USD: parseRate(usdData?.SATIS),
        EUR: parseRate(eurData?.SATIS),
        GBP: parseRate(gbpData?.SATIS)
      };

      set({ 
        rates: newRates, 
        lastUpdated: new Date().toISOString().split('T')[0],
        loading: false 
      });

      console.log("Kurlar başarıyla güncellendi:", newRates);
      return newRates;
    } catch (error) {
      console.error('Kur çekme hatası:', error.message);
      set({ loading: false });
      return get().rates;
    }
  },

  // Belirli bir para biriminin kurunu getir
  getRate: (currency) => {
    return get().rates[currency] || 1;
  }
}));

export default useExchangeStore;